module.exports = __webpack_public_path__ + "img/add-plue.a470745b.svg";